import log from "../log";

export default class AdsIMA {
	constructor(addata, startAd, endAd, moverBarra, dimensions) {
		this.addata = addata;
		this.startAd = startAd;
		this.endAd = endAd;
		this.moverBarra = moverBarra;
		this.onAdError = this.onAdError.bind(this);
		this.onAdsManagerLoaded = this.onAdsManagerLoaded.bind(this);
		this.createAdDisplayContainer = this.createAdDisplayContainer.bind(this);
		this.playAds = this.playAds.bind(this);
		this.onAdEvent = this.onAdEvent.bind(this);
		this.onAdError = this.onAdError.bind(this);
		this.barraCarga = this.barraCarga.bind(this);
		this.updateTimer = this.updateTimer.bind(this);
		this.width = dimensions.size_x;
		this.heigth = dimensions.size_y;
	}

	init() {
		this.videoContent = document.getElementById("ad_video");
		this.setupIMA();
	}

	setupIMA() {
		if (typeof google === "undefined") {
			this.endAd();
			return;
		}

		google.ima.settings.VpaidMode = "ENABLED";
		google.ima.settings.setLocale = document
			.getElementsByTagName("html")[0]
			.getAttribute("lang");
		this.createAdDisplayContainer();
		this.adsLoader = new google.ima.AdsLoader(this.adDisplayContainer);

		// Listen and respond to ads loaded and error events.
		this.adsLoader.addEventListener(
			google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
			this.onAdsManagerLoaded,
			false
		);
		this.adsLoader.addEventListener(
			google.ima.AdErrorEvent.Type.AD_ERROR,
			this.onAdError,
			false
		);

		// Request video ads.
		const adsRequest = new google.ima.AdsRequest();
		const addata = this.addata;
		let VAST = `https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/1043750/Preroll&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&url=${addata.referer}&description_url=${addata.description_url}&correlator=${addata.timestamp}`;

		// log(__filename, { VAST });

		adsRequest.adTagUrl = VAST;
		//
		adsRequest.forceNonLinearFullSlot = true;

		// Specify the linear and nonlinear slot sizes. This helps the SDK to
		// select the correct creative if multiple are returned.
		adsRequest.linearAdSlotWidth = 640;
		adsRequest.linearAdSlotHeight = 480;

		adsRequest.nonLinearAdSlotWidth = 640;
		adsRequest.nonLinearAdSlotHeight = 480;

		this.adsLoader.requestAds(adsRequest);
	}

	// eslint-disable-next-line class-methods-use-this
	createAdDisplayContainer() {
		// We assume the adContainer is the DOM id of the element that will house
		// the ads.
		this.adDisplayContainer = new google.ima.AdDisplayContainer(
			document.getElementById("adContainer"),
			this.videoContent
		);
	}

	onAdsManagerLoaded(adsManagerLoadedEvent) {
		const adsRenderingSettings = new google.ima.AdsRenderingSettings();
		adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;
		// videoContent should be set to the content video element.
		this.adsManager = adsManagerLoadedEvent.getAdsManager(
			this.videoContent,
			adsRenderingSettings
		);

		// Add listeners to the required events.
		this.adsManager.addEventListener(
			google.ima.AdErrorEvent.Type.AD_ERROR,
			this.onAdError
		);

		this.adsManager.addEventListener(
			google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
			this.onAdEvent
		);

		// Listen to any additional events, if necessary.
		this.adsManager.addEventListener(
			google.ima.AdEvent.Type.LOADED,
			this.onAdEvent
		);
		this.adsManager.addEventListener(
			google.ima.AdEvent.Type.USER_CLOSE,
			this.onAdEvent
		);

		this.adsManager.addEventListener(
			google.ima.AdEvent.Type.STARTED,
			this.onAdEvent
		);
		this.adsManager.addEventListener(
			google.ima.AdEvent.Type.COMPLETE,
			this.onAdEvent
		);
		this.playAds();
	}

	playAds() {
		window.setTimeout(() => {
			if (this.videoContent.innerHTML == "") {
				console.log("Paso el tiempo máximo de espera");
				this.endAd();
			}
		}, 17000);
		// Initialize the container. Must be done via a user action on mobile devices.

		this.adDisplayContainer.initialize();

		try {
			// Initialize the ads manager. Ad rules playlist will start at this time.
			this.adsManager.init(this.width, this.heigth, google.ima.ViewMode.NORMAL);
			// Call play to start showing the ad. Single video and overlay ads will
			// start at this time; the call will be ignored for ad rules.
			this.adsManager.start();
		} catch (adError) {
			console.info("[ads.js]", "adError reporta error");
			console.info("[ads.js]", "adError:", adError);
			this.endAd();
		}
	}

	onAdEvent(adEvent) {
		// Retrieve the ad from the event. Some events (e.g. ALL_ADS_COMPLETED)
		// don't have ad object associated.
		this.ad = adEvent.getAd();
		switch (adEvent.type) {
			case google.ima.AdEvent.Type.LOADED:
				this.startAd();
				console.info("[ads.js]", "Primer evento realizado por el ad");

				// This is the first event sent for an ad - it is possible to
				// determine whether the ad is a video ad or an overlay.
				if (!this.ad.isLinear()) {
					console.info("[ads.js]", "Anuncio no es ad.isLinear()");
					// Position AdDisplayContainer correctly for overlay.
					// Use ad.width and ad.height.
					this.videoContent.play();
				}
				break;
			case google.ima.AdEvent.Type.STARTED:
				// This event indicates the ad has started - the video player
				// can adjust the UI, for example display a pause button and
				// remaining time.
				console.info("[ads.js]", "ad.isLinear(): ", this.ad.isLinear());
				if (this.ad.isLinear()) {
					// For a linear ad, a timer can be started to poll for
					// the remaining time.
					this.time =
						this.ad.getDuration() > this.adsManager.getRemainingTime()
							? this.ad.getDuration()
							: this.adsManager.getRemainingTime();
					this.lastRemaining = -1;
					this.remainingBanner = 16;

					console.info("[ads.js]", "Setup Inicial Vars:");
					console.info("[ads.js]", "time: ", this.time);
					console.info("[ads.js]", "this.lastRemaining: ", this.lastRemaining);
					console.info(
						"[ads.js]",
						"this.remainingBanner: ",
						this.remainingBanner
					);

					this.startAd();

					this.intervalTimer = setInterval(this.updateTimer, 500); // every 500ms
				}
				break;
			case google.ima.AdEvent.Type.COMPLETE:
			case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
			case google.ima.AdEvent.Type.USER_CLOSE:
			case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
				// This event indicates the ad has finished - the video player
				// can perform appropriate UI actions, such as removing the timer for
				// remaining time detection.
				log(__filename, `Terminando anuncio debido a ${adEvent.type}`);
				clearInterval(this.intervalTimer);
				this.endAd();
				break;
			default:
				console.info("[ads.js]", "Usuario tiene adEvent.type no considerado");
				console.log("[ads.js]", adEvent.type);
		}
	}

	onAdError(adErrorEvent) {
		// Handle the error logging.
		console.info("[ads.js]", "Se anuncio error en el ad, terminar");
		console.info("[ads.js]", adErrorEvent.getError());
		if (typeof this.adsManager !== "undefined") {
			this.adsManager.destroy();
		}
		console.log(this);
		this.endAd();
	}

	barraCarga(remaining, duration) {
		this.moverBarra(remaining, duration);
	}

	updateTimer() {
		console.info("[ads.js]", "updateTimer call");
		console.info("[ads.js]", "this.adRemoved: ", this.adRemoved);
		if (!this.adRemoved) {
			const remainingTime = this.adsManager.getRemainingTime();
			this.time =
				this.time > this.ad.getDuration()
					? this.time
					: this.ad.getDuration() > this.adsManager.getRemainingTime()
					? this.ad.getDuration()
					: this.adsManager.getRemainingTime();
			console.info("[ads.js]", "Anuncio de video");
			console.info("[ads.js]", "remainiG: ", remainingTime);
			console.info("[ads.js]", "this.time: ", this.time);
			// Es video, todo va bien
			if (this.time != -1) {
				this.lastRemaining = remainingTime;
				this.barraCarga(remainingTime, this.time);
				if (remainingTime <= -1) {
					clearInterval(this.intervalTimer);
					this.endAd();
					this.adRemoved = true;
				}
			} else {
				console.info(
					"[ads.js]",
					"Es otro tipo, vamos a tener que mover la barra a mano"
				);

				console.info(
					"[ads.js]",
					"this.remainingBanner: ",
					this.remainingBanner
				);
				if (this.remainingBanner >= 0) {
					this.remainingBanner -= 0.5;
					this.barraCarga(remainingTime, 16);
				}
			}
			console.info("[ads.js]", "this.remainingBanner: ", this.remainingBanner);
			if (this.remainingBanner == 0) {
				clearInterval(this.intervalTimer);
				this.endAd();
				this.adRemoved = true;
			}
		}
	}
}
